import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../public/assets/icons/403-emoji.svg'


const _hoisted_1 = { class: "forbidden-403" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("img", { src: _imports_0 }, null, -1 /* CACHED */)),
    _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Your user does not have access to this content", -1 /* CACHED */)),
    _createElementVNode("p", null, [
      _cache[0] || (_cache[0] = _createTextVNode(" We couldn't find what you are looking for! Please check that you have access to the content you are trying to open. If this problem persists please contact ", -1 /* CACHED */)),
      _createElementVNode("a", { href: _ctx.mailto }, "support@attensi.com", 8 /* PROPS */, _hoisted_2)
    ])
  ]))
}